import {Component, OnInit} from '@angular/core';
import { InterfacesService } from '../interfaces.service';
import {UntypedFormControl} from "@angular/forms";
import {NgxSpinnerService} from "ngx-spinner";
import {DatePipe} from "@angular/common";
import {TipoInterfaces} from "@shared/enums/TipoInterfaces";

@Component({
  selector: 'app-interfaz-documentos-comerciales',
  templateUrl: './interfaz-documentos-comerciales.component.html',
  styleUrls: ['./interfaz-documentos-comerciales.component.scss']
})
export class InterfaceDocumentosComercialesComponent implements OnInit {
  interfaces = [];
  interfacesFiltradas;
  interfazSeleccionada;
  mensajeError;
  error;
  cargandoInterfaces: boolean;
  buscadorFormControl = new UntypedFormControl();

  constructor(public interfacesService: InterfacesService, private spinner: NgxSpinnerService, private datePipe: DatePipe) {}

  ngOnInit(): void {
    this.obtenerDatosDocumentosComerciales();
  }

  obtenerDatosDocumentosComerciales() {
    this.cargandoInterfaces = true;
    this.spinner.show('spinnerGrafico');
    this.interfacesService.obtenerInterfazDesdeLogicApp(TipoInterfaces.COMERCIALES).then(data => {
      this.error = false;
      const interfacesLista = this.transformarJSON(data);
      this.interfaces = [];
      //Ordeno la lista según la maqueta
      interfacesLista.sort((a, b) => a.nombre.localeCompare(b.nombre));
      this.interfaces = this.interfaces.concat(interfacesLista);
      this.interfacesFiltradas = this.interfaces;
      this.cargandoInterfaces = false;
      this.spinner.hide('spinnerGrafico');
    }).catch(() => {
      this.error = true;
      this.interfaces = [];
      this.interfacesFiltradas = this.interfaces;
      this.mensajeError = 'Error al conectarse con la interfaz Documentos Comercial'
      this.cargandoInterfaces = false;
      this.spinner.hide('spinnerGrafico');
    })
  }

  filtrarInterfaces() {
    this.interfacesFiltradas = this.interfaces.filter(i => i.nombre.toLowerCase().includes(this.buscador.value.toLowerCase()));
  }

  transformarJSON(jsonData) {
    const interfazMapeo = {
      "AltaCliente": "Alta clientes",
      "FacturaPDC": "Facturas",
      "NotaPDC": "Nota débito/crédito"
    };
    return Object.keys(jsonData).map((key) => {
      const registros = jsonData[key];
      let estado = "SinError";
      const pendientes = [];
      const error = [];
      const encabezadoData = {
        "AltaCliente": {
          encabezados: ["Rázon Social", "CUIT", "Cuenta SAP", "Cuenta"],
          registros: (r) => [
            r.RazonSocial,
            r.CUIT,
            r.NroCuentaLP0,
            r.NroCuenta
          ]
        },
        "FacturaPDC": {
          encabezados: ["Aeroplanta", "CUIT", "Tipo documento", "Nro. documento legal", "Fecha documento"],
          registros: (r) => [
            r.DetalleDoc[0].aeroplanta,
            r.Documento.CUIT,
            r.Documento.TipoDeDocumento,
            r.Documento.NroDocumentolegal,
            this.datePipe.transform(r.Documento.FechaDeDocumento, 'dd/MM/yyy HH:mm a')
          ]
        },
        "NotaPDC": {
          encabezados: ["CUIT", "Tipo documento", "Nro. documento legal", "Fecha documento"],
          registros: (r) => [
            r.Documento.CUIT,
            r.Documento.TipoDeDocumento,
            r.Documento.NroDocumentolegal,
            this.datePipe.transform(r.Documento.FechaDeDocumento, 'dd/MM/yyy HH:mm a')
          ]
        }
      }[key];
      registros.forEach(r => {
        const registroTransformado = encabezadoData.registros(r);
        if (r.Estado?.toLocaleLowerCase() === "error") {
          estado = "error";
          error.push(registroTransformado);
        } else if (r.Estado?.toLocaleLowerCase === "pendiente") {
          pendientes.push(registroTransformado);
          if (estado.toLocaleLowerCase() !== "error") {
            estado = "pendiente";
          }
        } else {
          pendientes.push(registroTransformado);
        }
      });
      // Si hay registros pendientes y el estado no es "ERROR", asegura que el estado sea "Pendiente"
      if (estado !== "error" && pendientes.length > 0) {
        estado = "pendiente";
      }
      const interfacesDocComerciales = {
        nombre: interfazMapeo[key],
        estado: estado,
        pendientes: {
          encabezados: encabezadoData.encabezados,
          registros: pendientes
        },
        error: {
          encabezados: encabezadoData.encabezados,
          registros: error
        }
      };
      return interfacesDocComerciales;
    });
  }

  mostrarInterfaz(event) {
    this.interfazSeleccionada = event;
  }

  get buscador() {
    return this.buscadorFormControl;
  }
}

